import request, { ACCEPT_HEADER_V2 } from '@utils/request';
import { Property } from 'shared-types/Property';
import { AnnouncementSchema } from './schemas';
import { PaginatedResponse } from '@features/state';

export async function getAnnouncements(slug: Property['slug'], language?: string) {
  const path = language
    ? `store/marketing/site/${slug}/announcements/${language}`
    : `store/marketing/site/${slug}/announcements`;

  const { data } = await request.base.get(path, {
    headers: {
      Accept: ACCEPT_HEADER_V2,
    },
  });

  return PaginatedResponse(AnnouncementSchema).parse(data);
}
